import Bitmap from "../../bitmap";
import Color from "../../models/color";
import { BaseBlockPack } from "./BaseBlockPack";
import { drawCurvedBorder } from "./utils/borderUtils";

export default class RoundedBlockPack extends BaseBlockPack {
  protected getBorderStyle(): 'default' | 'thick' {
    return 'thick';
  }

  drawBlock(
    bit: Bitmap,
    x: number,
    y: number,
    side: number,
    width: number,
    color: Color,
    to: number[]
  ): void {
    this.drawRawBlock(bit, x, y, side, width, color);
    const borderWidth = this.getBorderWidth(width);
    this.drawBlockCorner(bit, x, y, side, width, borderWidth, color, to);
  }

  private drawRawBlock(
    bit: Bitmap,
    x: number,
    y: number,
    side: number,
    width: number,
    color: Color
  ): void {
    let rx: number = 0,
      ry: number = 0,
      rw: number = width,
      rh: number = width;

    const bw = this.getBorderWidth(width);
    const smallRadius = Math.max(2, Math.floor(width / 8));

    // Left border - draw with curved edges
    if (side & 1) {
      drawCurvedBorder(bit, x, y, bw, width, 'left', smallRadius, color.shade(5));
      rx = bw;
      rw -= bw;
    }
    
    // Top border - draw with curved edges
    if (side & 2) {
      drawCurvedBorder(bit, x, y, width, bw, 'top', smallRadius, color.shade(5));
      ry = bw;
      rh -= bw;
    }
    
    // Right border - draw with curved edges
    if (side & 4) {
      drawCurvedBorder(bit, x + width - bw, y, bw, width, 'right', smallRadius, color.shade(3));
      rw -= bw;
    }
    
    // Bottom border - draw with curved edges
    if (side & 8) {
      drawCurvedBorder(bit, x, y + width - bw, width, bw, 'bottom', smallRadius, color.shade(3));
      rh -= bw;
    }

    // Draw fill
    if (rw > 0 && rh > 0) {
      this.drawBlockFill(bit, x + rx, y + ry, rw, rh, color);
    }
  }
}

